module.exports = "/_next/static/images/about-us-bg-92616a3cecbb28322ab27bd402bd3d20.png.webp";